var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"common_arrow",style:({'height': (_vm.height + "px"), 'width': (_vm.width + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }